import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "Services/Common/errorApiHandleUtils";
import { checkFilter } from "Services/Common/filterUtils";
import { categoryProductService } from "Services/Axios/categoryProductService";

export const getCategoryProduct = createAsyncThunk(
    'categoryProduct/getCategoryProduct',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await categoryProductService.getCategoryProduct(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const submitCategoryProduct = createAsyncThunk(
    'categoryProduct/submitCategoryProduct',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('name', data.name);

            let response;
            if (data.id) {
                response = await categoryProductService.updateCategoryProduct(data.id, formData);
            } else {
                response = await categoryProductService.createCategoryProduct(formData);
            }
            data.successCallback && data.successCallback();
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deleteCategoryProduct = createAsyncThunk(
    'categoryProduct/deleteCategoryProduct',
    async (id, { rejectWithValue }) => {
        try {
            const response = await categoryProductService.deleteCategoryProduct(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);